import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import {getStyle} from '../../styles/styles'
import { getIncomingFundsVersionComparer, getIncomingFundsVersionsByDeal } from '../../networking/NetworkingFunds';
import VersionsScreen from '../shared/Versions/VersionsScreen';

var style = getStyle();

const initialDate = new Date();
export default class IncomingFundVersionsByDealScreen extends React.Component {
    state = {        
        incomingVersions: [],
        columnDetail: []
    }

    componentDidMount(){
        if(this.props.open)
        {
            this.loadVersions(this.props.entityID);
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.entityID !== this.props.entityID || (prevProps.open !== this.props.open && this.props.open))
        {
            this.loadVersions(this.props.entityID);
        }
    }

    loadVersions = (dealHeaderID) =>{

        if(dealHeaderID > 0)
        {
            getIncomingFundsVersionsByDeal(dealHeaderID).then(
                (json)=>{
                    if (json !== null && json !== undefined) {
                        if (json.result !== undefined) {
                            this.setState({incomingVersions: json.result})
                        }
                        if (json.columnDetail != null) {
                            const _columnDetail = JSON.parse(json.columnDetail);
                            this.setState({columnDetail: _columnDetail})
                        }
                    }
                }
            )
        }
        else
        {
            this.setState({outgoingVersions: [],
                columnDetail: []})
        }
    }

    handleExitClick = () => {
        this.props.close();
    }

    getVersionComparer = (selectedVersions) =>{
        if(selectedVersions.length === 2)
        {
            getIncomingFundsVersionComparer(this.props.entityID, selectedVersions[0], selectedVersions[1]).then(
                (json) =>{
                    if(json === undefined){
                        this.setState({differences: []});
                    }else{
                        this.setState({differences: json.data});
                    }
                }
            )
        }
    }

    render(){

        return(
            <Dialog open={this.props.open} onClose={this.handleExitClick} maxWidth={"md"} fullWidth={true}>
                <DialogTitle>Incoming Funds Versions</DialogTitle>
                <DialogContent dividers>
                    <VersionsScreen versions ={this.state.incomingVersions} columnDetail={this.state.columnDetail} EntityType={'Incoming Funds'}
                                differences = {this.state.differences} onClickVersionComparer={this.getVersionComparer}/>
                </DialogContent>
                <DialogActions>
                    <button className="uk-button uk-button-green" key={"exit"} onClick={this.handleExitClick}>Exit</button>
                </DialogActions>
            </Dialog>
            
        );
    }
}